<template>
  <MediaBlock
    v-if="videoUrl"
    :id="item?.fields.id ?? `section-${item.sys.id}`"
    :cols="mappedCols"
    :media="mediaItem"
    :cols-centered="item.fields.videoCenteredInRow ?? false"
    :content-centered="item.fields.videoCentered ?? false"
    v-bind="
      ContentfulLivePreview.getProps({
        entryId: item.sys.id,
        fieldId: 'title'
      })
    "
  />
</template>

<script setup lang="ts">
import { MediaBlock } from '@hypercodestudio/basler-components';
import { generateVideoObject } from '~/utils/generateVideoObject';
import { mapColsWidth } from '~/utils/mapColsWidth';
import { videoUrlCalculator } from '~/utils/videoUrlCalculator';
import type { IVideo } from '~/lib/ContentfulService';
import { ContentfulLivePreview } from '@contentful/live-preview';

type Props = {
  item: IVideo;
};

const props = defineProps<Props>();

const videoUrl = computed(
  () =>
    videoUrlCalculator(props.item.fields) ??
    videoUrlCalculator(props.item.fields, true)
);

const mediaItem = computed(() => {
  return generateVideoObject(props.item.fields);
});

const mappedCols = computed(() => mapColsWidth(props.item.fields.videoWidth));
</script>
